import axios from 'axios';
import { API_URL } from 'constants/config';
import ls from 'localstorage-slim';
import { store } from 'store/index';
import { storeCsrfToken } from 'redux/csrfSlice';

export const normalAxios = axios.create();

axios.interceptors.request.use(
  async (config) => {
    config.withCredentials = true;

    if (config.method !== 'get') {
      let {
        csrf: { csrf_token },
      } = store.getState();

      if (!csrf_token) {
        const {
          data: { csrfToken },
        } = await normalAxios.get(`${API_URL}/auth/csrf-token`, { withCredentials: true });

        store.dispatch(storeCsrfToken({ csrf_token: csrfToken }));

        csrf_token = csrfToken;
      }

      config.headers['x-csrf-token'] = csrf_token;

      config.headers['activerole'] = ls.get('activeRole') ? JSON.parse(ls.get('activeRole')).id : '';
    }
    return config;
  },
  (error) => {
    // Do something with request error

    return Promise.reject(error);
  },
);

// Add a response interceptor

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refresh_token = ls.get('refresh_token');
        const { id } = JSON.parse(ls.get('memberDetails'));

        const res = await axios.post(
          `${API_URL}/auth/refresh-token`,
          { refresh_token, user_id: id },
          {
            headers: {
              organisationid: `${ls.get('orgId')}`,
            },
            withCredentials: true,
          },
        );

        if (res.status === 200) {
          const access_token = res.data.data?.token;

          if (!access_token) {
            ls.clear();
            window.location.href = '/logout';
            return Promise.reject(error);
          }

          ls.set('token', access_token);
          originalRequest.headers['Authorization'] = 'Bearer ' + access_token;

          return axios(originalRequest);
        }
      } catch (refreshError) {
        console.log('refreshError >> ', refreshError);
        ls.clear();
        window.location.href = '/logout';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axios;
